<script setup lang="ts">
import type { Component } from "vue";

type Props = {
  title?: string;
  icon?: Component;
};

const { title, icon } = defineProps<Props>();
</script>

<template>
  <div
    class="flex flex-col gap-4 rounded-sm border-2 border-kekkle-dark bg-gray-50 p-4 dark:bg-kekkle-dark-light"
  >
    <div v-if="title || $slots.title || icon" class="flex items-center gap-2">
      <component
        :is="icon"
        v-if="icon"
        class="h-5 w-5 text-kekkle-dark dark:text-slate-200"
      />
      <slot name="title">
        <h3 v-if="title" class="font-bold text-kekkle-dark dark:text-slate-200">
          {{ title }}
        </h3>
      </slot>
    </div>

    <slot />
  </div>
</template>
